import React, { useState } from "react";

type Props = {
  onKeyDown: (event: any) => void;
  onChange: (event: any) => void;
  onBlur: (event: any) => void;
  placeholder: string;
  name: string;
  value?: string;
  icon?: string;
  error: boolean;
  message?: string;
};

const normalInput = "w-full placeholder-gray-500 bg-gray-50 border border-gray-300 text-gray-900 text-xl rounded-full focus:outline-cyan-500 focus:border-cyan-400 block  pl-20 p-3 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:outline-cyan-500 dark:focus:border-cyan-400"
const errorInput = "shakeError w-full dark:focus:ring-red-500 placeholder-gray-500 bg-gray-50 border border-red-400 text-gray-900 text-xl rounded-full focus:outline-cyan-500 focus:border-cyan-400 block  pl-20 p-3  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:outline-cyan-500 dark:focus:border-cyan-400"

function Input({ onChange,onBlur,onKeyDown, name, placeholder,error,message, value = "",icon }: Props) {

  return (
    <div>
      <div className="relative" >
        <div className="flex absolute inset-y-0 mt-1 left-5 items-center pl-3 pointer-events-none">
          <img src={icon} className="mx-auto" alt="*" />
        </div>
            <input
              className={error ? errorInput : normalInput }
              onChange={event => onChange(event)}
              onBlur={event => onBlur(event)}
              onKeyDown={event => onKeyDown(event ) }
              name={name}
              placeholder={placeholder}
              value={value}
            />
      </div>
      {error ? <p className="text-red-500 text-center text-sm mt-1">{message}</p> : null}
    </div>
  );
}

export default Input;